const StandardStrike = require('./StandardStrike');
const BattleCalc = require('../BattleCalc');
const EventEmitter = require('eventemitter3');
const { logError } = require('../logger');

const MeleeAttack = function (battleState) {
  this.handle = 'melee_attack';
  this.physical = true;
  this.weapon = true;
  this.melee = true;
  this.harm = true;

  this.standardStrike = new StandardStrike(this, battleState);

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return victim && victim.unit;
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return;
    }

    setTimeout(() => {
      try {
        const result = this.standardStrike.execute(
          actor,
          victim,
          actor.poppet
            ? 0
            : BattleCalc.getEquippedAbility(actor, 'melee_attack').damage,
          true
        );
        result.abilityHandle = this.handle;
        result.actorId = actor.uid;
        result.victimId = victim.uid;
        result.allPieces = battleState.allPieces;
        this.eventEmitter.emit('result', result);
      } catch (err) {
        logError(err, {
          module: 'MeleeAttack',
          func: 'execute',
          actor,
          victim,
        });
        return { success: false };
      }
    }, BattleCalc.getCooldown(actor) * 1000 * 0.35);
  };
};
module.exports = MeleeAttack;
